export const PROJECT_TABLE_FIELD = {
  name: 'name',
  tool: 'tool',
  updated_at: 'updated_at',
} as const;

export type ProjectTableField = (typeof PROJECT_TABLE_FIELD)[keyof typeof PROJECT_TABLE_FIELD];

export const TABLE_PROJECT_ACTIONS = {
  click: 'click',
  delete: 'delete',
  rename: 'rename',
  move: 'move',
  favorite: 'favorite',
} as const;

export type TableProjectAction = (typeof TABLE_PROJECT_ACTIONS)[keyof typeof TABLE_PROJECT_ACTIONS];
